import { useState } from 'react';

// Same-origin path through web_api_server (v4). Never point at the Mastra
// port directly from the browser — the proxy in web_api_server is the only
// authorized entry point for Mastra UI and API.
const MASTRA_BASE = '/mastra';

type Tab = 'swagger' | 'studio';

export function MastraPage() {
  const [activeTab, setActiveTab] = useState<Tab>('studio');

  return (
    <div className="-m-5 flex flex-col overflow-hidden" style={{ height: 'calc(100vh - 50px)' }}>
      <div className="flex shrink-0 border-b bg-background px-4">
        <button
          className={`px-4 py-2 text-sm font-medium border-b-2 ${activeTab === 'studio' ? 'border-blue-400 text-blue-400' : 'border-transparent text-muted-foreground hover:text-foreground'}`}
          onClick={() => setActiveTab('studio')}
        >
          Studio
        </button>
        <button
          className={`px-4 py-2 text-sm font-medium border-b-2 ${activeTab === 'swagger' ? 'border-blue-400 text-blue-400' : 'border-transparent text-muted-foreground hover:text-foreground'}`}
          onClick={() => setActiveTab('swagger')}
        >
          Swagger
        </button>
      </div>
      <iframe
        src={`${MASTRA_BASE}/swagger-ui`}
        title="Swagger"
        className={`w-full flex-1 border-0 ${activeTab === 'swagger' ? '' : 'hidden'}`}
      />
      <iframe
        src={MASTRA_BASE}
        title="Studio"
        className={`w-full flex-1 border-0 ${activeTab === 'studio' ? '' : 'hidden'}`}
      />
    </div>
  );
}
